import { useFlags } from "launchdarkly-react-client-sdk";

export const useSavedLessons = (): boolean => {
  const { savedLessons } = useFlags();

  return savedLessons;
};

// One tour card in the `intro-highlighted-content-card` LD JSON flag payload.
// The shape mirrors CardTemplate's props: LD authors the card content directly.
export interface HighlightedContentCard {
  id?: string | number;
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  buttonText?: string;
  variant?: string;
  primaryCard?: boolean;
  imageAltText?: string;
  videoCard?: boolean;
  vimeoId?: string;
  videoHeader?: string;
  // bundle values (see CONTENT_BUNDLES) that must be present for the card to show
  showIf?: string[];
}

export interface IntroHighlightedContent {
  aiOnlyItems?: HighlightedContentCard[];
  defaultItems?: HighlightedContentCard[];
}

// LD JSON flag — undefined until the flag payload loads.
export const useIntroHighlightedContent = (): IntroHighlightedContent | undefined => {
  const { introHighlightedContentCard } = useFlags();

  return introHighlightedContentCard;
};
